import React from "react";
import PropTypes from "prop-types";
import { useDictionary } from "hooks";
import { isFunction, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import Icon from "@cayuse/shared-react.components.icon";
import Text from "@cayuse/shared-react.components.form.inputs.text";
import CovertButton from "@cayuse/shared-react.components.covert-button";

import styles from "./styles.css";


const SimpleSearchBar = ({ onChange, value, ...rest }) => {
	const dictionary = useDictionary("components.simpleSearchBar");
	const hasValue = isNonEmptyString(value);

	const handleChange = event => {
		if (isFunction(onChange)) {
			onChange({ value: event.target.value });
		}
	};

	const clearValue = () => {
		if (isFunction(onChange)) {
			onChange({ value: "" });
		}
	};

	return (
		<div data-component="SimpleSearchBar" className={`${styles.simpleSearchBar} ${hasValue ? styles.hasValue : ""}`}>
			<Icon name="search" className={styles.searchIcon} />
			<Text className={styles.input} value={value || ""} onChange={handleChange} {...rest} />
			<CovertButton
				aria-label={dictionary.searchButtonAriaLabel || "Clear search"}
				onClick={() => clearValue()}
				className={styles.SimpleSearchBarClearButton}
				tabIndex="0"
			>
				<Icon name="times" className={styles.clearIcon}/>
			</CovertButton>
		</div>
	);
};

SimpleSearchBar.propTypes = {
	onClick: PropTypes.func
};

export default SimpleSearchBar;